import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateContact } from 'api/contacts/use-create-contact.ts';
import { UserRole, useRoleGuard } from 'shared/hooks/use-role-guard.ts';
import { FormDrawerWithButton, EFormDrawerWithButtonIconType } from 'components/common/form-drawer-with-button';
import type { IContactFormFields } from 'components/contacts/contact-form';
import { ContactForm } from 'components/contacts/contact-form';
import type { ICreateContactProps } from 'components/contacts/create-contact/types';

export const CreateContact: React.FC<ICreateContactProps> = (props) => {
  const { clientId, bthLabel, textBtn = false, onCreate } = props;
  const { t } = useTranslation();

  const isAllow = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.customer_manager]);

  const { mutateAsync: createContact, isLoading } = useCreateContact();

  const handleFinish = async (value: IContactFormFields) => {
    const result = await createContact({ ...value, clientId });
    if (onCreate) onCreate(result);
  };

  if (!isAllow) return null;

  return (
    <FormDrawerWithButton
      formComponent={ContactForm}
      title={t('contact:create_contact')}
      isLoading={isLoading}
      iconType={textBtn ? EFormDrawerWithButtonIconType.NONE : EFormDrawerWithButtonIconType.CREATE}
      buttonType={textBtn ? 'link' : 'primary'}
      buttonLabel={bthLabel || t('contact:contact')}
      onFinish={handleFinish}
    />
  );
};
